import {
  KlassesPendingSummaryTotalFilters,
  getKlassesPendingSummaryTotal,
} from '@/data/services/klassAnalyticsServices';

export const klassAnalyticsQueries = {
  all: ['klassAnalytics'] as const,

  pendingSummaryTotal: (filters: KlassesPendingSummaryTotalFilters = {}) => ({
    queryKey: [
      ...klassAnalyticsQueries.all,
      'pendingSummaryTotal',
      { filters },
    ] as const,
    queryFn: () => getKlassesPendingSummaryTotal(filters),
  }),
};
